<template>
  <!-- Page heading for every in-app screen: home | parent | Current page.
       The last item is the page name and is shown largest. -->
  <nav class="page-breadcrumb" aria-label="Breadcrumb">
    <router-link :to="homeRoute" class="crumb-home" title="Dashboard">
      <v-icon size="22" color="#64748b">mdi-home-outline</v-icon>
    </router-link>
    <template v-for="(item, i) in items">
      <span :key="'sep' + i" class="crumb-sep">|</span>
      <router-link
        v-if="item.to && i < items.length - 1"
        :key="'item' + i"
        :to="item.to"
        class="crumb-link"
      >{{ item.text }}</router-link>
      <span
        v-else
        :key="'item' + i"
        :class="i === items.length - 1 ? 'crumb-current' : 'crumb-link crumb-plain'"
      >{{ item.text }}</span>
    </template>
  </nav>
</template>

<script>
export default {
  name: "PageBreadcrumb",
  props: {
    // [{ text: "Purchase", to: "/PurchaseList" }, { text: "Issue & Receipt" }]
    items: { type: Array, default: () => [] },
  },
  computed: {
    homeRoute() {
      var userType = (this.$store && this.$store.state.userType) || localStorage.getItem("userType");
      if (userType === "SuperAdmin") return "/superadminDashboard";
      if (userType === "JewelleryAdmin") return "/JewelleryDashboard";
      return "/StaffDashboard";
    },
  },
};
</script>

<style scoped>
.page-breadcrumb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 4px;
  font-family: "Plus Jakarta Sans", "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  line-height: 1.2;
}
.crumb-home {
  display: inline-flex;
  text-decoration: none;
}
.crumb-sep {
  color: #cbd5e1;
  font-size: 22px;
  font-weight: 300;
  margin: 0 10px;
}
.crumb-link {
  font-size: 18px;
  font-weight: 500;
  color: #64748b;
  text-decoration: none;
  letter-spacing: -0.01em;
}
a.crumb-link:hover {
  color: #9a6b27;
}
.crumb-current {
  font-size: 24px;
  font-weight: 700;
  color: #9a6b27;
  letter-spacing: -0.02em;
}
@media (max-width: 600px) {
  .crumb-link {
    font-size: 15px;
  }
  .crumb-current {
    font-size: 20px;
  }
  .crumb-sep {
    font-size: 18px;
    margin: 0 6px;
  }
}
</style>
